import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchData from "../data/SearchData";

const SearchBar = () => {
    const [query, setQuery] = useState("");
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();

        const match = SearchData.find((item) =>
            item.name.toLowerCase().includes(query.toLowerCase())
        );

        if (match) {
            navigate(match.path);
        } else {
            alert("No results found.");
        }

        setQuery("");
    };

    return (
        <form onSubmit={handleSubmit} className="flex items-center">
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search..."
                className="px-3 py-1 rounded-full text-black placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
            <button
                type="submit"
                className="ml-2 px-4 py-1 bg-[#F29E38] text-primaryrounded-full font-semibold hover:bg-opacity-90"
            >
                Go
            </button>
        </form>
    );
};

export default SearchBar;
